module.exports = __webpack_public_path__ + "static/media/logo-5g-fibra-horizontal.7254b707.png";